import { useEffect, useState } from 'react';
import { RoleI } from 'types';
import rolesApi from 'Api/axios/roles-api';

interface Props {
  init?: boolean;
}

const useRolesApi = ({ init = false }: Props = {}) => {
  /**
   * Variable que almacena todos los roles disponibles en la base de datos.
   */
  const [data, setData] = useState<Array<RoleI>>([]);

  /**
   * Variable para almacenar el estado de carga de los datos.
   */
  const [loading, setLoading] = useState(false);

  /**
   * Variable para almacenar un estado de error.
   */
  const [error, setError] = useState<string | null>();

  const fetchRoles = async () => {
    setLoading(true);
    const response = await rolesApi.readAll();
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchRoles();
    }
  }, []);

  return {
    data,
    loading,
    error,
    fetchRoles,
  };
};

export default useRolesApi;
